import { render, staticRenderFns } from "./MetricsWrapper.vue?vue&type=template&id=06206f49&"
import script from "./MetricsWrapper.vue?vue&type=script&lang=js&"
export * from "./MetricsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports